import styled from 'styled-components';

export const ColorPickerWrapper = styled.input.attrs({ type: 'color' })`
  margin-left: 5px;
  margin-bottom: 10px;
  outline: none;
  padding: 0;
  height: 20px;
  width: 45px;
  -webkit-appearance: menulist-button;
`;
